import Vue from 'vue';
import App from './App.vue';
import router from './router';
import { store } from './store/store';
import vuetify from './plugins/vuetify';
import { i18n } from './i18n';
import Vuelidate from 'vuelidate';
import axios from 'axios';
import firebase from 'firebase/app';
import 'firebase/auth';
import { firebaseConfig } from './firebase';
import * as VueGoogleMaps from 'vue2-google-maps';


// initialize firebase
firebase.initializeApp(firebaseConfig)
firebase.auth().useDeviceLanguage();
Vue.use(firebase)
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GMAP_APIKEY,
    libraries: 'places', 
  },
})
axios.defaults.baseURL = 'https://gooday-proto.firebaseio.com/'
axios.defaults.headers.get['Accepts'] = 'application/json'
Vue.use(Vuelidate);
Vue.config.productionTip = false
const app = new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
})
// mount app after firebase is initialized
firebase.auth().onAuthStateChanged(
  () => { 
    store.commit('auth/verifyLogin')
    app.$mount('#app') }
)
